import React from "react";
import "./AddToCalendarCmsMessage.scss";

const AddToCalendarCmsMessage = () => (
    <div className="add-to-calendar-cms-message -margin-bottom--15 -margin-top--10 -text--center">
        <p>
            If there are overall Campaign and/or specific Classification start
            and end dates, an Add to Calendar Widget will display here. This
            allows registrants to quickly add the event to their preferred
            digital calendar.
        </p>
    </div>
);

export default AddToCalendarCmsMessage;
